import axios from "axios";

const pageScroll = { locks: 0, saved: null };
const liftedAncestors = new Map();

function liftStackingAncestors(node) {
  const lifted = [];
  for (let el = node && node.parentElement; el && el !== document.body; el = el.parentElement) {
    const cs = getComputedStyle(el);
    const parentDisplay = el.parentElement ? getComputedStyle(el.parentElement).display : '';
    const zApplies = cs.position !== 'static' || /flex|grid/.test(parentDisplay);
    const createsContext = ['fixed', 'sticky'].includes(cs.position) || cs.zIndex !== 'auto'
      || cs.transform !== 'none' || cs.filter !== 'none' || cs.opacity !== '1' || cs.isolation === 'isolate';
    if (!zApplies || !createsContext) continue;
    let entry = liftedAncestors.get(el);
    if (!entry) {
      entry = { zIndex: el.style.zIndex, count: 0 };
      liftedAncestors.set(el, entry);
      el.style.zIndex = '2147483000';
    }
    entry.count++;
    lifted.push(el);
  }
  return lifted;
}

function releaseStackingAncestors(nodes) {
  nodes.forEach(el => {
    const entry = liftedAncestors.get(el);
    if (!entry || --entry.count > 0) return;
    el.style.zIndex = entry.zIndex;
    liftedAncestors.delete(el);
  });
}

export const VueGallerySlideshowNew = {
  template: `
  <transition name="modal" @after-leave="releaseStacking">
    <div
      v-if="imgIndex !== null"
      class="vgs"
      @click="picture360 && imgIndex == 0 ? '' : close() "
    >
      <button
        type="button"
        class="vgs__close"
        @click="close"
      >
        &times;
      </button>
      <button
        v-if="isMultiple"
        type="button"
        data-action="photo scroll"
        class="vgs__prev LBX-adobe-gclickvdp"
        @click.stop="onPrev"
      >
      <svg width="12" height="16" viewBox="0 0 12 16" fill="none" class="fill-current text-white w-6 h-6" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.0488 7.62939e-06L0.524384 8.00001L11.0488 16L11.0488 13.3333L3.81327 8.00001L11.0488 2.66667L11.0488 7.62939e-06Z" />
      </svg>
      </button>
      <div
        v-if="images"
        class="vgs__container top-img flex items-center justify-center"
      >  
        <iframe v-if="isSelectedMp4" :src="media" controls="true" width="80%" style="background:#ffffff;margin: 0 auto;" class="h-[42vw] 2xl:h-[630px] 2xl:w-[1220px]">
        </iframe>   
        <Pano v-else-if="isSelected360" :source="imageUrl"></Pano>
        <div v-else class="vgs__container__img">
            <picture>
            <source v-if="imageUrlWebp" :srcset="imageUrlWebp" type="image/webp"/>
            <source :srcset="imageUrl" type="image/jpg"/>
            <img
              class="vgs__container__img"
              :src="imageUrl"
              :alt="alt"
              @click.stop="onNext"
              @error="onFullResError"
            >
            </picture>
        </div>
        <slot></slot>
      </div>
      <button
        v-if="isMultiple"
        type="button"
        data-action="photo scroll"
        class="vgs__next LBX-adobe-gclickvdp"
        @click.stop="onNext"
      >
      <svg width="11" height="16" viewBox="0 0 11 16" fill="none" class="fill-current text-white w-6 h-6" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.30019e-06 16L10.5244 8.00001L1.60081e-06 7.62939e-06L-5.82818e-07 2.66667L7.23555 8.00001L1.72359e-06 13.3333L2.30019e-06 16Z"/>
      </svg>
      </button>
      <div
        v-if="isMultiple"
        ref="gallery"
        class="vgs__gallery"
      >
        <div
          v-if="images"
          class="vgs__gallery__title"
        >
          {{ imgIndex + 1 }} / {{ images.length }}
        </div>
        <div
          v-if="images"
          class="vgs__gallery__container"
          :style="{ transform: 'translate(' + galleryXPos + 'px, 0)' }"
        >
        <span  v-for="(img, i) in images">
          <svg v-if="videomp4 == true && i==0" loading="lazy"
            :key="i"
            class="vgs__gallery__container__img bg-white px-[18px] py-5"
            :class="{ 'vgs__gallery__container__img--active': i === imgIndex}"
            :alt="typeof img === 'string' ? '' : img.alt"
            @click.stop="onClickThumb(img, i)"
              >
              <path
                  d="M38.169 48.521H1.052C0 48.521 0 48.521 0 47.516V.998C0 0 0 0 .974 0h74.375c.989 0 .989 0 .989.981v46.535c0 .974 0 .982-.974.982l-37.195.023zm-.078-3.575h33.573c1.06 0 1.067 0 1.067-1.028V4.565c0-.982 0-.982-.958-.982H4.55c-.958 0-.966 0-.966.974v39.36c0 1.029 0 1.029 1.06 1.029H38.09zM44.962 57.433H15.984a1.37 1.37 0 00-1.402.779 3.763 3.763 0 01-6.512-.086 1.145 1.145 0 00-1.176-.662H2.415a4.913 4.913 0 01-.678 0 1.217 1.217 0 01.11-2.43h5.288a.78.78 0 00.78-.468 3.793 3.793 0 016.885-.039.778.778 0 00.78.468H73.797c.294-.016.588-.016.881 0a1.247 1.247 0 011.114 1.09 1.176 1.176 0 01-1.013 1.27c-.357.065-.72.09-1.082.078H44.962z" />
              <path
                  d="M38.208 8.569a15.75 15.75 0 11-.28 31.5 15.75 15.75 0 01.28-31.5zm-4.362 15.703v6.855c0 .88.42 1.114 1.153.647 3.567-2.239 7.127-4.482 10.68-6.73.778-.507.778-.943 0-1.457-3.522-2.228-7.042-4.445-10.563-6.652-.865-.538-1.254-.32-1.262.685-.016 2.181-.008 4.393-.008 6.613v.04z" />
          </svg>
          <svg v-else-if="(picture360 == true && i==0 && !videomp4) || (videomp4 && picture360 == true && i==1)" loading="lazy"
              xmlns="http://www.w3.org/2000/svg"
              :key="i"
              class="vgs__gallery__container__img bg-white px-[18px] py-5"
              :class="{ 'vgs__gallery__container__img--active': i === imgIndex}"
              :alt="typeof img === 'string' ? '' : img.alt"
              @click.stop="onClickThumb(img, i)"
              >
              <path
                  d="M19.64 30.657l1.307-1.956a8.502 8.502 0 004.11 1.11c1.809 0 2.54-.364 2.54-1.788 0-1.254-.569-1.693-2.709-1.693h-2.343v-2.194h2.296c1.787 0 2.383-.295 2.383-1.361s-.5-1.254-2.22-1.254a8.049 8.049 0 00-3.603.84l-1.436-1.881a11.068 11.068 0 015.302-1.192c3.068 0 4.74.747 4.74 2.954 0 1.712-.48 2.458-1.57 2.822 1.354.332 1.93 1.116 1.93 3.135 0 3.003-2.134 3.762-5.14 3.762a10.214 10.214 0 01-5.587-1.304zM31.362 26.5c0-5.067 1.564-7.01 8.173-7.01h1.24v2.225H39.42c-4.93 0-5.146 1.424-5.289 2.872.61-.765 1.85-1.129 3.962-1.129 3.426 0 4.462 1.524 4.462 4.133 0 2.752-1.395 4.39-5.417 4.39-4.124-.007-5.776-1.85-5.776-5.481zm8.478 1.191c0-1.33-.555-2.176-2.614-2.176-1.916 0-2.939.665-2.939 2.038 0 1.662.968 2.295 2.919 2.295 2.207 0 2.634-.84 2.634-2.157zM43.462 25.628c0-4.145 1.558-6.34 5.824-6.34s5.824 2.195 5.824 6.34-1.626 6.346-5.824 6.346-5.824-2.207-5.824-6.346zm8.709 0c0-2.602-.57-3.963-2.885-3.963-2.316 0-2.919 1.36-2.919 3.963 0 2.602.59 4.088 2.919 4.088 2.33 0 2.885-1.498 2.885-4.088zM55.787 21.326c0-.617.264-1.208.735-1.645A2.618 2.618 0 0158.3 19c.666 0 1.305.245 1.776.681.471.437.736 1.028.736 1.645s-.264 1.21-.736 1.645a2.617 2.617 0 01-1.776.682 2.618 2.618 0 01-1.777-.682 2.243 2.243 0 01-.735-1.645zm3.717.038c0-.677-.304-1.21-1.212-1.21-.907 0-1.199.533-1.199 1.21 0 .677.292 1.21 1.2 1.21.907 0 1.177-.533 1.177-1.21h.034z" />
              <path
                  d="M16.18 25.49v4.39S4.878 39.993 33.529 43.85v-4.866l16.929 9.914L33.725 59v-5.236s-23.498-1.467-28.353-13.77c0 0-3.474-8.534 10.808-14.504zM71.626 35.072c-2.296-6.98-12.717-9.582-12.717-9.582v3.944c13.915 9.676-9.318 14.422-9.318 14.422L60.69 50.46l.636-.275c2.797-1.148 13.794-6.309 10.3-15.112z" />
              <path
                  d="M.275 12H2.72V.885H.275V12zM5.105 12H7.46V4.5l5.505 7.5h2.25V.885h-2.34V7.89L7.76.885H5.105V12zM20.409 12h2.475V3.105h3.84V.885h-10.17v2.22h3.855V12zM28.044 12h8.415V9.87h-5.955V7.41h5.745V5.265h-5.745v-2.16H36.4V.885h-8.355V12zM45.287 12h2.625l-2.205-3.96c1.845-.585 2.34-1.995 2.34-3.525 0-2.13-.84-3.63-4.335-3.63h-5.37V12h2.4V8.31h2.49L45.287 12zm-4.545-5.805v-3.21h2.865c1.395 0 1.965.33 1.965 1.62 0 1.26-.6 1.59-1.935 1.59h-2.895zM50.094 12h2.445V.885h-2.445V12zM60.204 12.18c3.54 0 5.895-1.56 5.895-5.745 0-4.17-2.355-5.73-5.895-5.73-3.54 0-5.88 1.56-5.88 5.73 0 4.185 2.34 5.745 5.88 5.745zm0-2.16c-2.55 0-3.405-1.365-3.405-3.54s.855-3.525 3.405-3.525 3.405 1.35 3.405 3.525-.855 3.54-3.405 3.54zM74.657 12h2.625l-2.205-3.96c1.845-.585 2.34-1.995 2.34-3.525 0-2.13-.84-3.63-4.335-3.63h-5.37V12h2.4V8.31h2.49L74.657 12zm-4.545-5.805v-3.21h2.865c1.395 0 1.965.33 1.965 1.62 0 1.26-.6 1.59-1.935 1.59h-2.895z"
                  fill="#222" />
          </svg>

          <img v-else
            :key="i"
            class="vgs__gallery__container__img"
            :src="brokenThumbs[i] ? fallbackSrc : thumbUrl(img)"
            :class="{ 'vgs__gallery__container__img--active': i === imgIndex}"
            :alt="typeof img === 'string' ? '' : img.alt"
            @click.stop="onClickThumb(img, i)"
            @error="onThumbError(i)"
          >

          </span>
        </div>
      </div>
    </div>
  </transition>
`,
  props: {
    images: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: null,
    },
    picture360: {
      type: Boolean,
      required: false,
      default: false,
    },
    videomp4: {
      type: Boolean,
      required: false,
      default: false,
    },
    media: {
      type: String,
      required: "",
      default: "",
    },
  },
  data() {
    return {
      imgIndex: this.index,
      image: null,
      galleryXPos: 0,
      thumbnailWidth: 140,
      isSelected360: false,
      isSelectedMp4: false,
      fullResFailed: {},
      brokenMain: {},
      brokenThumbs: {},
    };
  },
  created: function () {
    //console.log("Created");
  },
  computed: {
    imageUrl() {
      this.validateImages();
      if (this.brokenMain[this.imgIndex] && this.fallbackSrc) {
        return this.fallbackSrc;
      }
      const img = this.images[this.imgIndex];
      // Fullscreen: la CDN nueva es paramétrica y capa al tamaño fuente, así
      // que pedimos la rendition grande; el array queda en 800 para el strip.
      if (
        typeof img === "string" &&
        img.includes("vehicleimages.leadboxhq.com") &&
        !this.fullResFailed[this.imgIndex]
      ) {
        return img.replace(/-[^-/]+(\.\w+)(?=$|\?)/i, "-1600$1");
      }
      return img;
    },
    imageUrlWebp() {
      const url = this.imageUrl;
      if (typeof url === "string" && url.includes("vehicleimages.leadboxhq.com")) {
        return url.replace(".jpg", ".webp");
      }
      return null;
    },
    fallbackSrc() {
      // El padre (vdp-gallery / -rv, inline-template) trae defaultPicture/comingsoon/incoming.
      const p = this.$parent || {};
      if (!p.defaultPicture) return "";
      if (p.comingsoon === true && p.incoming === true) {
        return p.defaultPicture.split("-photo").join("-photo-incoming");
      }
      return p.defaultPicture;
    },
    videoUrl() {
      //console.log('entromp4');
      return this.media;
    },
    alt() {
      const img = this.images[this.imgIndex];
      if (typeof img === "object") {
        return img.alt;
      }

      return "";
    },
    isMultiple() {
      return this.images.length > 1;
    },
  },
  watch: {
    index(val, prev) {
      this.imgIndex = val;

      // updateThumbails when popup
      if (prev == null && val != null) {
        const checkGalleryClass = document.querySelector('.veh-title-gallery-section-layout');
        if (checkGalleryClass) {
          document.querySelector('.veh-title-gallery-section-layout').classList.add('veh-title-gallery-section-layout-open');
        }

        this.$nextTick(() => {
          this.validateImages();
          this.updateThumbails();
        });
      }
    },
    imgIndex: {
      immediate: true,
      handler(val, prev) {
        if (val !== null && prev == null) {
          this.lockPageScroll();
          if (!this.stackingLift) this.stackingLift = liftStackingAncestors(this.$el);
        } else if (val === null && prev != null) {
          this.unlockPageScroll();
        }
      },
    },
  },
  beforeDestroy() {
    this.unlockPageScroll();
    this.releaseStacking();
  },
  mounted() {
    if(this.images && this.images.length > 0){
      this.images.forEach((img, index) => {
        // La CDN nueva no soporta HEAD (404 falso siempre) y sus URLs no
        // llevan los sufijos -gallery/-XXL que este check corrige: saltarla.
        if (typeof img !== 'string' || img.includes('vehicleimages.leadboxhq.com')) return;
        this.checkUrlExists(img).then((exists) => {
          if (!exists) {
            console.warn("** --> URL not found: ", this.images[index]);
            this.images[index] = this.images[index].split('-gallery.jpg').join('');
            this.images[index] = this.images[index].split('-XXL').join('');
          }
        });
      });
    }

    window.addEventListener("keydown", (e) => {
      if (e.keyCode === 37) {
        this.onPrev();
      } else if (e.keyCode === 39) {
        this.onNext();
      } else if (e.keyCode === 27) {
        this.close();
      }
    });

    window.addEventListener(
      "touchstart",
      (e) => {
        // Con el lightbox cerrado, este preventDefault mataba el scroll táctil de toda la VDP.
        if (this.imgIndex === null) return;
        window.touchobj = e.changedTouches[0];
        window.dist = 0;
        window.startX = window.touchobj.pageX;
        window.startY = window.touchobj.pageY;
        window.startTime = new Date().getTime(); // record time when finger first makes contact with surface
        e.preventDefault();
      },
      false
    );

    window.addEventListener(
      "touchend",
      (e) => {
        if (this.imgIndex === null) return;
        if (this.isSelected360 == false) {
          window.touchobj = e.changedTouches[0];
          window.distX = window.touchobj.pageX - window.startX; // get horizontal dist traveled by finger while in contact with surface
          window.distY = window.touchobj.pageY - window.startY; // get vertical dist traveled by finger while in contact with surface
          window.elapsedTime = new Date().getTime() - window.startTime; // get time elapsed // 2nd condition for horizontal swipe met
          if (Math.abs(window.distX) < 30) return;
          if (window.distX < 0) {
            this.onNext();
          } else if (window.distX > 0){
            this.onPrev(); // if dist traveled is negative, it indicates left swipe
          }
        }
      },
      false
    );
  },
  methods: {
    releaseStacking() {
      if (!this.stackingLift || this.imgIndex !== null) return;
      releaseStackingAncestors(this.stackingLift);
      this.stackingLift = null;
    },
    lockPageScroll() {
      if (this.holdsScrollLock) return;
      this.holdsScrollLock = true;
      if (pageScroll.locks++ > 0) return;
      const html = document.documentElement;
      const gap = window.innerWidth - html.clientWidth;
      pageScroll.saved = { overflow: html.style.overflow, paddingRight: html.style.paddingRight };
      html.style.overflow = 'hidden';
      if (gap > 0) html.style.paddingRight = `${gap}px`;
    },
    unlockPageScroll() {
      if (!this.holdsScrollLock) return;
      this.holdsScrollLock = false;
      if (--pageScroll.locks > 0) return;
      const html = document.documentElement;
      html.style.overflow = pageScroll.saved.overflow;
      html.style.paddingRight = pageScroll.saved.paddingRight;
      pageScroll.saved = null;
    },
    checkUrlExists(url) {
      url = url.replace("http:", "https:");
      return axios.head(url)
        .then(response => true) // URL válida
        .catch(error => {
          if (error.response && error.response.status === 404) {
            return false; // URL no válida
          }
          return false; // Otro error
        });
    },
    close() {
      const eventData = {
        imgIndex: this.imgIndex,
      };
      this.imgIndex = null;
      const checkGalleryClass = document.querySelector('.veh-title-gallery-section-layout');
      if (checkGalleryClass) {
          document.querySelector('.veh-title-gallery-section-layout').classList.remove('veh-title-gallery-section-layout-open');
      }
      
      this.$emit("close", eventData);
    },
    validateImages() {
      if (
        this.picture360 &&
        ((this.imgIndex == 1 && this.videomp4) ||
          (this.imgIndex == 0 && !this.videomp4))
      ) {
        this.isSelected360 = true;
      } else {
        this.isSelected360 = false;
      }
      if (this.videomp4 && this.imgIndex == 0) {
        this.isSelectedMp4 = true;
      } else {
        this.isSelectedMp4 = false;
      }
    },
    onPrev() {
      if (this.imgIndex === null) return;
      if (this.imgIndex > 0) {
        this.imgIndex--;
      } else {
        this.imgIndex = this.images.length - 1;
      }
      this.validateImages();
      this.updateThumbails();
    },
    onNext() {
      if (this.imgIndex === null) return;
      if (this.imgIndex < this.images.length - 1) {
        this.imgIndex++;
      } else {
        this.imgIndex = 0;
      }
      this.validateImages();
      this.updateThumbails();
    },
    onClickThumb(image, index) {
      this.imgIndex = index;
      this.validateImages();
      this.updateThumbails();
    },
    thumbUrl(img) {
      const url = typeof img === "string" ? img : (img && img.url) || "";
      // Strip del lightbox (~140px): a la CDN nueva pedirle la rendition chica
      // en vez de arrastrar la del array completo.
      if (url.includes("vehicleimages.leadboxhq.com")) {
        return url.replace(/-[^-/]+(\.\w+)(?=$|\?)/i, "-200$1");
      }
      return url.replace(/-XXL/g, "-thumb.jpg");
    },
    onFullResError() {
      if (this.imgIndex == null) return;
      const img = this.images[this.imgIndex];
      const isNewCdn = typeof img === "string" && img.includes("vehicleimages.leadboxhq.com");
      // Si la rendition grande falla, volver a la URL original del array;
      // si esa también falla, caer al coming soon como hace la galería.
      if (isNewCdn && !this.fullResFailed[this.imgIndex]) {
        this.$set(this.fullResFailed, this.imgIndex, true);
      } else if (this.fallbackSrc && !this.brokenMain[this.imgIndex]) {
        this.$set(this.brokenMain, this.imgIndex, true);
      }
    },
    onThumbError(i) {
      if (this.fallbackSrc && !this.brokenThumbs[i]) {
        this.$set(this.brokenThumbs, i, true);
      }
    },
    updateThumbails() {
      if (!this.$refs.gallery) {
        return;
      }

      const galleryWidth = this.$refs.gallery.clientWidth;
      const currThumbsWidth = this.imgIndex * this.thumbnailWidth;
      const maxThumbsWidth = this.images.length * this.thumbnailWidth;
      const centerPos =
        Math.floor(galleryWidth / (this.thumbnailWidth * 2)) *
        this.thumbnailWidth;

      // Prevent scrolling of images if not needed
      if (maxThumbsWidth < galleryWidth) {
        return;
      }

      if (currThumbsWidth < centerPos) {
        this.galleryXPos = 0;
      } else if (
        currThumbsWidth >
        this.images.length * this.thumbnailWidth - galleryWidth + centerPos
      ) {
        this.galleryXPos = -(
          this.images.length * this.thumbnailWidth -
          galleryWidth -
          20
        );
      } else {
        this.galleryXPos = -(this.imgIndex * this.thumbnailWidth) + centerPos;
      }
    },
  },
};
